import { registerPlugin } from "@capacitor/core";

/**
 * Native bridge for background GPS tracking + the platform's "live activity"
 * surface (Android: foreground-service notification, iOS: ActivityKit Live
 * Activity). Implemented natively per-platform — see:
 *   android/.../LiveTrackingPlugin.java + RunTrackingService.java
 *   ios/App/App/LiveTrackingPlugin.swift
 *
 * On web this plugin is not registered; callers must check
 * Capacitor.isNativePlatform() first (see src/lib/tracking.js).
 */
const LiveTracking = registerPlugin("LiveTracking");

export default LiveTracking;
